import React from 'react';
const STATS = [{
  value: '6',
  label: 'Complete Modules'
}, {
  value: '1 + 5',
  label: 'Box Set & Bonuses'
}, {
  value: 'PRO',
  label: 'Coaching Level'
}, {
  value: 'Worldwide',
  label: 'Digital Access'
}];
export function Stats() {
  return <section aria-label="Key numbers" className="w-full bg-white px-4 pb-6 sm:px-6" data-id="element-203" data-mp="2ixp8giaoukw3">
      <div className="mx-auto max-w-5xl" data-id="element-204" data-mp="2nvh3hl6mqn4i">
        <p className="mb-2 text-center font-head text-[11px] font-semibold uppercase tracking-wider text-softgray sm:text-sm" data-id="element-205" data-mp="2985p7bj2cp0p">
          Built for padel coaches who want everything ready
        </p>
        <dl className="grid grid-cols-2 overflow-hidden rounded-xl border border-charcoal/10 bg-ivory lg:grid-cols-4" data-id="element-206" data-mp="207fwigp3ner7">
          {STATS.map(stat => <div key={stat.label} className="flex flex-col items-center justify-center border-charcoal/10 px-3 py-3 text-center sm:border-r sm:last:border-r-0" data-id="element-207" data-mp="2572aiscr4z12">
              <dt className="sr-only" data-id="element-208" data-mp="1v7uwe2y710cw">{stat.label}</dt>
              <dd className="font-display text-2xl uppercase leading-none text-brand-dark sm:text-3xl" data-id="element-209" data-mp="5587bahvq8gu">
                {stat.value}
              </dd>
              <p className="mt-1 font-head text-[10px] font-semibold uppercase tracking-wide text-softgray sm:text-xs" data-id="element-210" data-mp="6er3ab7k3cz">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
    </section>;
}